export const COMMUNITY_HUB_GROUP_IDS = [
  '5e1cf747-4ae0-40e8-b16c-0f797d4a93ad',
  '66a1a26b-1760-45b1-a926-667388091ebf',
  'a3b5707a-0371-4f95-8b86-db649af9c08e',
  'bbbec143-75d3-4518-9b63-9ecb3ecba5bb',
  'eb6a9402-a828-4502-8cf7-eb1e176d0e89',
  '948199ea-b438-4aea-8ccf-c6ada07a4b8f',
  'e71f798f-405f-431a-a406-f729e26a85dc'
]
